export default "__VITE_ASSET__DvPujT$F__"